<template>
    <div class="mx-auto col-lg-6 col-md-8 col-sm-12 header-margin">
        <div class="text-center p-2">
            <h3>{{ $t('withdrawal.emailSent.title') }}</h3>
        </div>

        <div class="mt-4">
            <div>{{ $t('withdrawal.emailSent.text[0]') }}</div>
            <div>{{ $t('withdrawal.emailSent.text[1]') }}</div>

            <div class="text-center pt-3">
                <button @click.prevent="handleClickClose" type="button" class="btn btn-outline-secondary">{{
                    $t('withdrawal.emailSent.close') }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import tokenService from './../../services/TokenService';

    export default {
        name: 'TokenWithdrawalConfirmEmailSent',

        methods: {
            async handleClickClose() {
                this.$router.push({name: 'withdrawalToken'});
            }
        }
    }
</script>

<style>

</style>
